import { CommunicationCard } from '@features/dashboard/specialistDashboard/specialistCards/communication';
import { RecommendationLetters } from '@features/dashboard/specialistDashboard/specialistCards/recommendationLetters';
// import { ReviewCard } from '@features/dashboard/specialistDashboard/specialistCards/reviewsCard';
import { UserCardWrapper } from '@features/dashboard/specialistDashboard/specialistCards/userCardWrapper';
import { WhatIOffer } from '@features/dashboard/specialistDashboard/specialistCards/WhatIOffer';
import { WorkExperienceCard } from '@features/dashboard/specialistDashboard/specialistCards/workExperienceCard';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { useUsersStore } from 'services/users';

import user from '../../../../assets/user.png';
import user1 from '../../../../assets/user1.jpg';
import user2 from '../../../../assets/user2.jpg';
import user3 from '../../../../assets/user3.jpg';
import { CompanyInfo } from '../specialistCards/comanyInfo';
import { ContactDetails } from '../specialistCards/contactDetails';
import './styles.css';

const data = {
	contact: {
		email: 'example@example.com',
		phoneNumber: '123-456-7890',
	},
	offer: {
		specialist: ['Apple (Malus Domestica)', 'Corn (Zea Mays)'],
		services: ['General Consultation', 'Creating a business plan'],
		specialized: [
			'Prunning and Trimming',
			'Irrigation and Water Management',
			'Sustainable Farming Practices',
		],
	},
	work: {
		title: 'I have worked for 8 years in 3 countries',
		experience: ['Spain - 2 years', 'Georgia - 3 years', 'United Kingdom - 3 years'],
		value:
			'With over a decade of hands-on experience in agronomy, I have collaborated with diverse farming communities and guided them towards higher yields and profitability.',
	},
	communication: {
		country: {
			flag: '🇪🇸',
			country: 'Spain',
		},
		speak: ['Spanish', 'English'],
	},
	letters: ['Recommendation_letter.pdf', 'Recommendation_letter_company.docx'],
	reviews: [
		{
			img: user,
			title: 'Andrea Boccelli',
			subtitle: 'General Consultation - Apple (Malus Domestica)',
			score: 4.5,
			date: '2023-10-01',
			text: 'Working with Enrique Rodriguez was an excellent experience. Their deep knowledge and practical advice significantly helped me improve my farming practices',
		},
		{
			img: user1,
			title: 'Alexander Thompson',
			subtitle: 'Creating a business plan - Corn (Zea Mays)',
			score: 3.5,
			date: '2024-10-01',
			text: 'They were responsive, patient, and provided valuable insights. I highly recommend Enrique Rodriguez to fellow farmers seeking expert guidance.',
		},
		{
			img: user2,
			title: 'Review Title',
			subtitle: 'Creating a business plan - Corn (Zea Mays)',
			score: 4.8,
			date: '2021-10-01',
			text: 'Working with Enrique Rodriguez was an excellent experience. Their deep knowledge and practical advice significantly helped me improve my farming practices.',
		},
		{
			img: user3,
			title: 'Review Title',
			subtitle: 'Creating a business plan - Corn (Zea Mays)',
			score: 4.1,
			date: '2022-10-01',
			text: 'They were responsive, patient, and provided valuable insights. I highly recommend Enrique Rodriguez to fellow farmers seeking expert guidance.',
		},
	],
};

export const SpecialistPage = () => {
	const { user } = useUsersStore();

	useAppbarTitle('myProfile');

	return (
		<div className=" flex flex-col max-md:justify-center max-md:items-center">
			<UserCardWrapper
				firstName={user?.first_name || ''}
				lastName={user?.last_name || ''}
				user={user}
				showEdit
			/>
			<div className="flex gap-[20px] mt-[20px] max-md:flex-col">
				<div className="flex flex-col gap-[20px] pb-5 w-full">
					{user?.company && <CompanyInfo />}
					<ContactDetails />
					<WhatIOffer />
				</div>
				<div className="flex flex-col gap-[20px] pb-5 w-full">
					<CommunicationCard />
					<RecommendationLetters />
					<WorkExperienceCard />
					{/* <ReviewCard data={data} /> */}
				</div>
			</div>
		</div>
	);
};
